import { cn } from '@/lib/utils';

// Canonical shadcn Skeleton — pure Tailwind (no Radix dep). A rounded grey
// box with a subtle pulse animation. M5-T3 stacks three of these in the
// AccountSidebar while the accounts query is loading.
function Skeleton({
  className,
  ...props
}: React.HTMLAttributes<HTMLDivElement>): React.JSX.Element {
  return (
    <div
      className={cn('animate-pulse rounded-md bg-muted', className)}
      {...props}
    />
  );
}

export { Skeleton };
